const Saetze = require('./saetze.js');
import {formatPrice,checkAusbildung,zeitmodell} from "./logic";

class Meister {

    constructor(dies, monate = 12, meisterGeb = 0, lehrgangsGeb = 0) {
        this.dies = dies;
        this.monate = monate;
        this.meisterGeb = meisterGeb;
        this.lehrgangsGeb = lehrgangsGeb;
        this.meiststueck = Saetze.MEISTER_STUECK;
        this.meiststueckanteil = Saetze.MEISTER_STUECK_ANTEIL;
        this.meistergebuehr = Saetze.MEISTER_GEBUEHR;
        this.meistergebuehranteil = Saetze.MEISTER_GEBUEHR_ANTEIL;
    }

    get null() {
        return this.berechneNull();
    }
    /**
     * 0 zurückgeben
     * @returns {string}
     */
    berechneNull() {
        return formatPrice(0);
    }

    /**
     * Lädt Nutzer-Eintrag Lehrgangsgebühr zurück
     * @returns {*}
     */
    get lehrgangsGebuehr(){
        this.lehrgGeb = this.dies
        return this.lehrgangsGeb
    }

    /**
     * Lädt Nutzer-Eintrag Lehrgangsgebühr aus Maske
     * @param $this
     */
    set lehrgGeb($this){
        let lG = 0;
        if($this.el$('meister_fragen.lehrgangsgeb')){
            lG = $this.el$('meister_fragen.lehrgangsgeb').value
        }
        this.lehrgangsGeb = lG;
    }

    get lehrgangszuschlag(){
        return this.berechneLehrgangZU()
    }
    berechneLehrgangZU(){
        let le_ergebnis = 0;
        let le_zwischen = 0;
        // Lehrgangsgebühr auslesen
        this.lehrgGeb = this.dies
        le_zwischen = this.lehrgangsGeb
        // Grenzen der Lehrgangs-und Prüfungsgebühren berücksichtigen
        if(le_zwischen>this.meistergebuehr){
            le_zwischen = this.meistergebuehr
        }else if(le_zwischen<=0){
            return formatPrice(0);
        }
        // Berechnung = Gebühren - Selbstanteil / Monate
        le_ergebnis = le_zwischen * (this.meistergebuehranteil/100) / this.monate
        return formatPrice(le_ergebnis);
    }

    /**
     * Lädt Nutzer-Eintrag Meisterstück-Gebühr zurück
     * @returns {*}
     */
    get meisterGebuehr(){
        this.meistGeb = this.dies
        return this.meisterGeb
    }

    /**
     * Lädt Nutzer-Eintrag Lehrgangsgebühr aus Maske
     * @param $this
     */
    set meistGeb($this){
        let mG = 0;
        if($this.el$('meister_fragen.kosten_meisterstueck')&&$this.el$('meister_fragen.meisterstueck').value==='ja'){
            mG = $this.el$('meister_fragen.kosten_meisterstueck').value
        }
        this.meisterGeb = mG;
    }

    get meisterzuschlag(){
        return this.berechneMeisterZU()
    }
    berechneMeisterZU(){
        let me_ergebnis = 0;
        let me_zwischen = 0;
        // MeisterStück auslesen
        this.meistGeb = this.dies
        // € Anteil berechnen, der maximal berücksichtigt/übernommen wird
        me_zwischen = this.meisterGeb * (this.meiststueckanteil/100) ;
        // Grenzen der Meisterstück-Gebühren berücksichtigen
        if(me_zwischen>this.meiststueck){
            me_zwischen = this.meiststueck
        }else if(me_zwischen<=0){
            return formatPrice(0);
        }
        // Berechnung = Gebühren / Monate
        me_ergebnis = me_zwischen / this.monate
        return formatPrice(me_ergebnis);
    }

}

function meisterzuschlagBerechnen($this, aus = false){
    const me = new Meister($this);
    if(aus){
        if(!zeitmodell($this)&&checkAusbildung($this)==='meister'){
            //console.log('Meister teilzeit -> berechnen')
            // Teilzeit, Meister
            $this.el$('results.lehrgangszuschlag').value = me.lehrgangszuschlag
            $this.el$('results.meisterzuschlag').value = me.meisterzuschlag
        }else{
            // alles nullen
            //console.log('Meister teilzeit -> nullen')
            $this.el$('results.lehrgangszuschlag').value = me.null
            $this.el$('results.meisterzuschlag').value = me.null
            //console.log('Meisterzuschlag null: '+$this.el$('results.lehrgangszuschlag').value)
        }
    } else {
        if(checkAusbildung($this)==='meister'){
            //console.log('Meister vollzeit -> berechnen')
            $this.el$('results.lehrgangszuschlag').value = me.lehrgangszuschlag
            $this.el$('results.meisterzuschlag').value = me.meisterzuschlag
        }else{
            //console.log('Meister vollzeit -> nullen')
            $this.el$('results.lehrgangszuschlag').value = me.null
            $this.el$('results.meisterzuschlag').value = me.null
        }
    }
}

/**
 * Funktionen exportieren
 */
export {meisterzuschlagBerechnen};
